<template>
    <div id="i-soci" class="i-soci section grey" v-if="this.dataLoaded">
        <div class="big-title" data-aos="new-animation" data-aos-init="aos-init" >
            <h1 v-html="this.splittedTitle(this.labelTitle)"></h1>
        </div>
        <div class="container">
            <h3>{{this.labelOcchiello}}</h3>
            <h1 data-aos="new-animation" data-aos-init="aos-init" class="animated-title" data-aos-delay="4000">{{this.labelTitle}}</h1>
            <div class="row" v-if="this.partnersImages">
                <div class="col-md-12 col-lg-6" v-for="(partner, index) in partners" :key="partner.id">
                    <div v-if="index <= 1" >
                        <div class="image" >
                            <img data-toggle="collapse" :href="'#asd'+partner.id" :src="'https://ptnlex-api-prod.interfase.tv/'+partner.imageUrl" alt="">
                        </div>
                        <h2 data-toggle="collapse" :href="'#asd'+partner.id">{{partner.attributes.title}}</h2>
                            <a class="btn btn-primary read-more" data-toggle="collapse" :href="'#asd'+partner.id" role="button" aria-expanded="false">{{labelReadMore}}</a>
                            <div class="collapse description" :id="'asd'+partner.id">
                            <p class="card card-body" v-html="partner.attributes.field_description.processed">
                             </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  name: 'section-i-soci',
  props: {
      dataPages: {
          type: String
      }
  },
  data:()=>{
        return {
            partners:[],
            partnersImages:[],
            dataLoaded:false
        }
  },
    computed:{
            labelOcchiello(){
                let label;
            if(this.$route.params.lang == "it"){
                label = "il team"
            } else {
                label = "the team"
            }
            return label
            },
        labelReadMore(){
            let label;
            if(this.$route.params.lang == "it"){
                label = "Maggiori informazioni"
            } else {
                label = "Read more"
            }
            return label
        },
        labelTitle(){
            let label;
            if(this.$route.params.lang == "it"){
                label = "I Soci"
            } else {
                label = "Partners"
            }
            return label
        }
    },
    methods:{
    splittedTitle: function (value) {
        return value.replace(/(?![^<]*>)[^<]/g, c => `<span>${c}</span>\n`);
    },
    findObjectbyKey(array, key, value){
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
        return null;
    },
    loadDataImages(){
        this.partners.forEach((e,index) => {
            let imageUrls = e.relationships.field_picture.links.related.href;
            if(e.relationships.field_picture.data!=null){
                fetch(imageUrls, {method: "GET", mode: 'cors'})
                .then(response=>{
                    return response.json()
                })
                .then(json=>{

                    this.partnersImages = json.data
                    this.partners[index].imageUrl = this.partnersImages.attributes.uri.url
                    
                    if(index==2){
                        this.dataLoaded = true
                    }
                })
                .catch(function(error) {  
                    console.log('Request failed', error)  
                });
            }
            
        });
    }
    },
    mounted(){
        fetch("https://ptnlex-api-prod.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/partner", {method: "GET", mode: 'cors'})
        .then(response=>{
            return response.json()
        })
        .then(json=>{
            this.partners = json.data
            this.loadDataImages()
        })
        .catch(function(error) {  
            console.log('Request failed', error)  
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
   h2 {
        cursor: pointer;
    }

.image {
    position: relative;
   
    img {
        cursor: pointer;
    }

    &:before{
        position: absolute;
        background: url("../assets/shadow-soci.png") center;
        width: 426px;
        content: "";
        display: block;
        height: 91px;
        bottom: -91px;
        left: 0;
        pointer-events: none;
    }
}

.i-soci {
    height: 100%;
    background: #E3E3E3;
    padding-top: 10rem;
    h2 {
        margin-top: 1rem;
    }
    .description {
    }
}

.i-soci .big-title h1{
    transform: translate3d(120%, 200%, 0);
}


@media (max-width:992px){

.i-soci {
    padding-top: 0rem;
}
.image {
    &:before{
        display: none;
    }
}
}

@media (max-width:768px){
    .i-soci{
        .row > div {
            margin-bottom: 1.5rem;
        }
    }
    .image img {
        width: 100%;
        height: auto;
    }
    .container h2 {
        margin-bottom: 0.4rem;
    }
}

</style>
